
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1744",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2646",
    d: "M23.447 19.987c-.679-.73-1.95-1.828-1.95-5.424A5.552 5.552 0 0017 9.108v-.733a1.125 1.125 0 00-1.125-1.125 1.125 1.125 0 00-1.124 1.125v.733a5.552 5.552 0 00-4.5 5.455c0 3.6-1.271 4.694-1.95 5.424A1.1 1.1 0 008 20.75a1.126 1.126 0 001.129 1.125h13.492a1.126 1.126 0 001.129-1.125 1.1 1.1 0 00-.303-.763zm-13.073.2a8.8 8.8 0 001.565-5.6v-.02a3.937 3.937 0 013.938-3.937 3.937 3.937 0 013.938 3.938v.02a8.8 8.8 0 001.565 5.6zm5.5 5.063a2.25 2.25 0 002.25-2.25h-4.5a2.25 2.25 0 002.251 2.25z",
    fill: "currentColor"
  })));
}

export { SvgInfo as default };
//# sourceMappingURL=info.svg.js.map
